/* global gsap */

export default class OffcanvasMenu {
	constructor(el) {
		if (!el) return;
		this.offcanvas = el;
		this.menu = this.offcanvas.querySelector('#primary-menu');
		this.menuItems = this.menu && this.menu.querySelectorAll('.menu-item');
		this.image = this.offcanvas.querySelector('.image-wrapper');
		this.texts = this.offcanvas.querySelector('.menu-texts-wrapper');

		this.init();
		this.events();
	}

	init() {
		this.resetMenuItems.bind(this)();
	}

	resetMenuItems() {
		this.menuItems && gsap.set(this.menuItems, { opacity: 0, y: '20px' });
		this.image && gsap.set(this.image, { opacity: 0, y: '-50px' });
		this.texts && gsap.set(this.texts, { opacity: 0, y: '50px' });
	}

	onMenuShown() {

		let tl = new gsap.timeline();
		this.menuItems && tl.to(this.menuItems, {
			duration: .4,
			opacity: 1,
			y: 0,
			stagger: .1,
		});

		this.image && gsap.to(this.image, {
			duration: .6,
			opacity: 1,
			y: 0,
		});

		this.texts && gsap.to(this.texts, {
			duration: .7,
			opacity: 1,
			y: 0,
		});
	}

	onMenuHidden() {
		this.resetMenuItems.bind(this)();
	}

	onMenuShow() {
		document.body.classList.add('main-menu-open');
	}

	onMenuHide() {
		document.body.classList.remove('main-menu-open');
	}

	events() {
		this.offcanvas.addEventListener('show.bs.offcanvas', this.onMenuShow.bind(this));
		this.offcanvas.addEventListener('shown.bs.offcanvas', this.onMenuShown.bind(this));
		this.offcanvas.addEventListener('hide.bs.offcanvas', this.onMenuHide.bind(this));
		this.offcanvas.addEventListener('hidden.bs.offcanvas', this.onMenuHidden.bind(this));
	}
}
